var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buildGeminiWeekPeriodTooltipLabel } from '@web/components/Apps/Gemini/geminiChartTooltipLabels';
import { formatGeminiUsageLevelLabel } from '@web/components/Apps/Gemini/geminiUsageLevel';
import { GEMINI_USAGE_LEVEL_COLORS_CONFIG } from '@web/config';
import { GEMINI_USAGE_LEVELS, resolveAverageGeminiUsageLevelFromCounts } from '@workalizer/shared/lib/gemini-usage-level';
import { toPercent } from '@workalizer/shared/utils';
export var geminiUsageLevelDistributionDataKey = function (prefix, level) { return "".concat(prefix).concat(level.charAt(0)).concat(level.slice(1).toLowerCase()); };
export var GEMINI_USAGE_LEVEL_DISTRIBUTION_BAR_CHART_CONFIGS = {
    previous: GEMINI_USAGE_LEVELS.map(function (level) { return ({
        dataKey: geminiUsageLevelDistributionDataKey('previous', level),
        fill: GEMINI_USAGE_LEVEL_COLORS_CONFIG[level].prevChartColor,
        stackId: 'previous'
    }); }),
    current: GEMINI_USAGE_LEVELS.map(function (level) { return ({
        dataKey: geminiUsageLevelDistributionDataKey('current', level),
        fill: GEMINI_USAGE_LEVEL_COLORS_CONFIG[level].chartColor,
        stackId: 'current'
    }); }),
    team: GEMINI_USAGE_LEVELS.map(function (level) { return ({
        dataKey: geminiUsageLevelDistributionDataKey('team', level),
        fill: GEMINI_USAGE_LEVEL_COLORS_CONFIG[level].teamChartColor,
        stackId: 'team'
    }); })
};
var appendLevelShares = function (row, prefix, levels, usersInScope) {
    for (var _i = 0, GEMINI_USAGE_LEVELS_1 = GEMINI_USAGE_LEVELS; _i < GEMINI_USAGE_LEVELS_1.length; _i++) {
        var level = GEMINI_USAGE_LEVELS_1[_i];
        row[geminiUsageLevelDistributionDataKey(prefix, level)] = toPercent(levels[level], usersInScope);
    }
};
export var buildGeminiUsageLevelDistributionChartData = function (segments, options) {
    return segments.map(function (segment) {
        var row = {
            name: segment.name,
            segmentId: segment.id,
            period: segment.period,
            levelCounts: segment.currentLevels,
            previousLevelCounts: segment.previousLevels,
            teamLevelCounts: segment.teamLevels,
            usersInScope: segment.usersInScope,
            teamUsersInScope: segment.teamUsersInScope,
            userCurrentLevel: segment.userCurrentLevel,
            userPreviousLevel: segment.userPreviousLevel
        };
        if (options.filterPeriodLabels) {
            row.currentPeriodComparisonLabel =
                options.filterPeriodLabels.currentPeriodComparisonLabel;
            row.previousPeriodLabel = options.filterPeriodLabels.previousPeriodLabel;
        }
        else if (segment.dateFrom && segment.dateTo) {
            row.currentPeriodComparisonLabel = buildGeminiWeekPeriodTooltipLabel(segment.dateFrom, segment.dateTo, options.dateFrom, options.dateTo);
            row.previousPeriodLabel = segment.previousPeriodLabel;
        }
        appendLevelShares(row, 'previous', segment.previousLevels, segment.usersInScope);
        appendLevelShares(row, 'current', segment.currentLevels, segment.usersInScope);
        if (segment.teamLevels && segment.teamUsersInScope) {
            appendLevelShares(row, 'team', segment.teamLevels, segment.teamUsersInScope);
            row.teamUserLevel = resolveAverageGeminiUsageLevelFromCounts(segment.teamLevels);
        }
        return row;
    });
};
export var GEMINI_USAGE_LEVEL_DISTRIBUTION_PREVIOUS_STACK_DATA_KEYS = GEMINI_USAGE_LEVEL_DISTRIBUTION_BAR_CHART_CONFIGS.previous.map(function (config) { return config.dataKey; });
export var GEMINI_USAGE_LEVEL_DISTRIBUTION_CURRENT_STACK_DATA_KEYS = GEMINI_USAGE_LEVEL_DISTRIBUTION_BAR_CHART_CONFIGS.current.map(function (config) { return config.dataKey; });
export var GEMINI_USAGE_LEVEL_DISTRIBUTION_TEAM_STACK_DATA_KEYS = GEMINI_USAGE_LEVEL_DISTRIBUTION_BAR_CHART_CONFIGS.team.map(function (config) { return config.dataKey; });
export var buildGeminiUsageLevelDistributionExportRows = function (data, isUserView, t, i18nPrefix, includeTeamAverage) {
    if (includeTeamAverage === void 0) { includeTeamAverage = false; }
    return data.segments.map(function (segment) {
        var _a, _b, _c;
        var _d;
        if (isUserView) {
            var teamLevel = includeTeamAverage && segment.teamLevels
                ? resolveAverageGeminiUsageLevelFromCounts(segment.teamLevels)
                : null;
            return __assign((_a = {}, _a[t("".concat(i18nPrefix, ".export.period"))] = (_d = segment.period) !== null && _d !== void 0 ? _d : segment.name, _a[t("".concat(i18nPrefix, ".export.currentUsageLevel"))] = segment.userCurrentLevel !== null &&
                segment.userCurrentLevel !== undefined
                ? formatGeminiUsageLevelLabel(segment.userCurrentLevel, true, t)
                : '', _a[t("".concat(i18nPrefix, ".export.previousUsageLevel"))] = segment.userPreviousLevel !== null &&
                segment.userPreviousLevel !== undefined
                ? formatGeminiUsageLevelLabel(segment.userPreviousLevel, true, t)
                : '', _a), (includeTeamAverage && (_b = {},
                _b[t('export.teamAverage')] = teamLevel !== null
                    ? formatGeminiUsageLevelLabel(teamLevel, true, t)
                    : '',
                _b)));
        }
        var row = (_c = {},
            _c[t("".concat(i18nPrefix, ".export.segment"))] = segment.name,
            _c);
        for (var _i = 0, GEMINI_USAGE_LEVELS_2 = GEMINI_USAGE_LEVELS; _i < GEMINI_USAGE_LEVELS_2.length; _i++) {
            var level = GEMINI_USAGE_LEVELS_2[_i];
            var label = formatGeminiUsageLevelLabel(level, true, t);
            row["".concat(t('export.current'), " ").concat(label)] =
                "".concat(segment.currentLevels[level], " (").concat(toPercent(segment.currentLevels[level], segment.usersInScope), "%)");
            row["".concat(t('export.previous'), " ").concat(label)] =
                "".concat(segment.previousLevels[level], " (").concat(toPercent(segment.previousLevels[level], segment.usersInScope), "%)");
            if (includeTeamAverage &&
                segment.teamLevels &&
                segment.teamUsersInScope) {
                row["".concat(t('export.teamAverage'), " ").concat(label)] =
                    "".concat(segment.teamLevels[level], " (").concat(toPercent(segment.teamLevels[level], segment.teamUsersInScope), "%)");
            }
        }
        return row;
    });
};
